import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'unset',
    },
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
  },
  icon: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.text.secondary,
  },
  tagsContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  tagChip: {
    height: 'auto',
    textTransform: 'uppercase',
    borderRadius: 0,
    '&:hover': {
      cursor: 'pointer',
      color: theme.palette.secondary.main,
    },
    marginBottom: 0,
  },
  tagLabel: {
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(12),
    padding: theme.spacing(1),
  },
}));
